import { css } from "glamor";

const sharedStyles = {
    size: {
        default: css({
            minWidth: "150px",
            minHeight: "32px",
            padding: "0 17px",
        }),
        small: css({
            minWidth: "120px",
            minHeight: "25px",
            padding: "5px 11px 5px 11px",
        }),
    },
};

export default sharedStyles;
